import { render } from "./AddNewOrderFormReferenceArea.vue?vue&type=template&id=3df053f2&ts=true"
import script from "./AddNewOrderFormReferenceArea.vue?vue&type=script&lang=ts"
export * from "./AddNewOrderFormReferenceArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__